import { writable } from 'svelte/store';

export const tages = writable(
  {
    "name": "",
    "group": "",
    "id": 0
  }
);